import { Checkbox, TextField, Typography, withStyles } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import React, { useEffect, useState } from "react"
import { NotificationConstants } from "../../../util/constants"

// Style
const styles = () => ({
  filterContainer: {
    display: "flex",
    flexDirection: "column",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
  },
  chipBox: {
    display: "flex",
    flexWrap: "wrap",
    margin: 0,
    padding: 0,
  },
  chip: {
    margin: "4px",
  },
  checkbox: {
    paddingLeft: 0,
  },
})

const NotificationSection = (props) => {
  const { classes, notificationClasses, availableClasses, onNotificationChange } = props
  const [selectedClasses, setSelectedClasses] = useState(
    notificationClasses.filter((c) => c !== NotificationConstants.NONE),
  )

  const getSearchableClasses = () => {
    let uniqueClassTax = new Set()
    if (availableClasses) {
      for (const k of Object.keys(availableClasses)) {
        for (const d of availableClasses[k]) {
          if (d.original_label) uniqueClassTax.add(d.original_label)
        }
      }
      uniqueClassTax = [...uniqueClassTax].sort()
    }
    return [...uniqueClassTax]
  }

  const handleSelectedClassChange = (newValue) => {
    setSelectedClasses(newValue)
    onNotificationChange(newValue)
  }

  const handleCheckChange = (event) => {
    const checked = event.target.checked
    if (checked) {
      setSelectedClasses([NotificationConstants.ALL])
      onNotificationChange([NotificationConstants.ALL])
    } else {
      setSelectedClasses([])
      onNotificationChange([])
    }
  }

  useEffect(() => {
    if (notificationClasses) {
      setSelectedClasses(notificationClasses.filter((c) => c !== NotificationConstants.NONE))
    }
  }, [notificationClasses])

  return (
    <div className={classes.filterContainer}>
      <div className={classes.checkboxContainer}>
        <Checkbox
          className={classes.checkbox}
          checked={selectedClasses.includes(NotificationConstants.ALL)}
          onChange={handleCheckChange}
          inputProps={{ "aria-label": "controlled" }}
        />
        <Typography variant="body1">Notify for all class names</Typography>
      </div>
      <Autocomplete
        multiple
        onChange={(_event, value) => handleSelectedClassChange(value)}
        value={selectedClasses.filter((className) => className !== NotificationConstants.ALL)}
        options={getSearchableClasses()}
        renderInput={(params) => <TextField {...params} label="Class Names" />}
      />
    </div>
  )
}

export default withStyles(styles)(NotificationSection)
